/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import './ButtonSwitch.scss';
import PropTypes from 'prop-types';

export function ButtonSwitch({ label1 = 'Option 1', label2 = 'Option 2', onClick = () => {} }) {
  const [activeTab, setActiveTab] = useState(0);

  const handleClick = (tabIndex) => {
    setActiveTab(tabIndex);
    onClick();
  };

  return (
    <div className="btn-switch bg-secondary rounded-4 d-flex justify-content-between p-4">
      <button
        type="button"
        className={`btn pe-4 ${activeTab === 0 ? 'active' : 'inactive'}`}
        onClick={() => handleClick(0)}>
        {label1}
      </button>

      <button
        type="button"
        className={`btn w-100 ${activeTab === 1 ? 'active' : 'inactive'}`}
        onClick={() => handleClick(1)}>
        {label2}
      </button>
    </div>
  );
}

ButtonSwitch.propTypes = {
  label1: PropTypes.string.isRequired,
  label2: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ButtonSwitch;
